import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Menu, Message } from "element-react";
import { message } from "antd";
import "./index.scss";
import { getToken, getCurrentUser } from "utils/storage";

class Nav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultActive: "1",
      opend: "0",
      dataList: [],
      //金融机构 7
      list4: [
        {
          title: "机构信息管理",
          path: "/entrance/personal/mechanismInfoManage",
        },
        {
          title: "产品管理记录",
          path: "/entrance/personal/productManageRecords",
        },
        {
          title: "审核管理记录",
          path: "/entrance/personal/auditManageRecords",
        },
      ],
      //培训机构 6
      list3: [
        {
          title: "机构信息管理",
          path: "/entrance/personal/mechanismInfoManage",
        },
        {
          title: "培训课程管理",
          path: "/entrance/personal/mechanismSubjectManage",
        },
        {
          title: "培训开班管理",
          path: "/entrance/personal/createClass",
        },
        {
          title: "违规学员管理",
          path: "/entrance/personal/violationStudent",
        },
        {
          title: "课程评价记录",
          path: "/entrance/personal/subjectEvaluationRecords",
        },
      ],
      //招聘企业 5
      list2: [
        {
          title: "企业信息管理",
          path: "/entrance/recruitEnterprise/enterpriseInfo",
        },
        {
          title: "职位发布",
          path: "/entrance/recruitEnterprise/jobPublish",
        },
        {
          title: "简历搜索",
          path: "/entrance/recruitEnterprise/resumeSearch",
        },
        {
          title: "收到的简历",
          path: "/entrance/recruitEnterprise/resumeReceived",
        },
        {
          title: "人才储备库",
          path: "/entrance/recruitEnterprise/talentReserve",
        },
        {
          title: "简历签约管理",
          path: "/entrance/recruitEnterprise/signingManage",
        },
      ],
      //退役军人 2
      list1: [
        {
          title: "个人信息管理",
          path: "/entrance/personal/userInfo",
        },
        {
          title: "简历管理",
          path: "/entrance/personal/resumeManage",
        },
        {
          title: "我的投递",
          path: "/entrance/personal/myDelivery",
        },
        {
          title: "职位收藏",
          path: "/entrance/personal/jobCollection",
        },
        {
          title: "课程学习记录",
          path: "/entrance/personal/courseLearningRecords",
        },
        {
          title: "申请培训记录",
          path: "/entrance/personal/applyTrainingRecords",
        },
        {
          title: "异地培训资金结算",
          path: "/entrance/personal/trainingFundSettlement",
        },
        {
          title: "技能培训记录",
          path: "/entrance/personal/skillsTrainingRecords",
        },
        {
          title: "创业服务记录",
          path: "/entrance/personal/entrepreneurshipServiceRecords",
        },
        {
          title: "创业基地入住记录",
          path: "/entrance/personal/entrepreneurshipBaseRecords",
        },
        {
          title: "金融产品记录",
          path: "/entrance/personal/financialProductRecords",
        },
        {
          title: "创业巡诊记录",
          path: "/entrance/personal/businessTourRecords",
        },
      ],
      userType: "",
    };
  }

  setDefaultActive = (index) => {
    this.setState({
      defaultActive: index,
    });
  };

  componentDidMount() {
    const { dataList, defaultActive, setDefaultActive } = this.props;
    setDefaultActive && setDefaultActive(this.setDefaultActive);
    if (!getCurrentUser()) {
      message.error("请先登录");
      window.location = "/login";
      return;
    }
    let userType = getCurrentUser().user_type;
    this.setState({ userType });

    if (Array.isArray(dataList) && dataList.length) {
      this.setState({ dataList });
    }
    this.setState({ defaultActive });
  }

  onOpen() {}
  onClose() {}
  onSelect(e) {
    const { userType, list1, list2, list3, list4 } = this.state;
    const { history } = this.props;
    this.setState({
      defaultActive: e,
    });
    console.log('list1e1path',list1[e - 1].path);
    console.log('list1e1path',e);
    
    switch (userType) {
      case "2":
        this.goLink(list1[e - 1].path);
        history.location.title = list1[e - 1].title;
        break;
      case "5":
        this.goLink(list2[e - 1].path);
        history.location.title = list2[e - 1].title;
        break;
      case "6":
        this.goLink(list3[e - 1].path);
        history.location.title = list3[e - 1].title;
        break;
      case "7":
        this.goLink(list4[e - 1].path);
        history.location.title = list4[e - 1].title;
        break;
      default:
        break;
    }
  }

  goLink = (path) => {
    this.props.history.push(path);
  };

  renderLeftNav(data, defaultActive) {
    return data.map((item, index) => {
      return (
        <div>
        <Menu.Item
          index={index + 1 + ""}
          key={item.title}
          className={[
            "menu-item",
            index + 1 == defaultActive ? "menu-item-active" : "",
          ].join(" ")}
        >
          {item.title}
        </Menu.Item>
        </div>
      );
    });
  }

  render() {
    let { defaultActive, userType, list1, list2, list3, list4 } = this.state;
    return (
      <Menu
        defaultActive={defaultActive + ""}
        className="el-menu-vertical-demo"
        onOpen={this.onOpen.bind(this)}
        onClose={this.onClose.bind(this)}
        onSelect={this.onSelect.bind(this)}
        style={{marginTop:15}}
      >
        {this.renderLeftNav(
          userType == 2
            ? list1
            : userType == 5
            ? list2
            : userType == 6
            ? list3
            : userType == 7
            ? list4
            : [],
          defaultActive
        )}
      </Menu>
    );
  }
}

export default Nav;
